/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OrganizationRoleIndexCollection } from '../models/OrganizationRoleIndexCollection'
import type { OrganizationRoleResource } from '../models/OrganizationRoleResource'
import type { PermissionFormatQuery } from '../models/PermissionFormatQuery'

import type { CancelablePromise } from '../core/CancelablePromise'
import type { BaseHttpRequest } from '../core/BaseHttpRequest'

export class OrganizationsRolesService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * List organization users.
     * @returns OrganizationRoleIndexCollection OK
     * @throws ApiError
     */
    public getOrganizationRoles({
        id
    }: {
        /**
         * ID of the retrieved resource.
         */
        id: number
    }): CancelablePromise<OrganizationRoleIndexCollection> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/organizations/{id}/roles',
            path: {
                id: id
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`
            }
        })
    }

    /**
     * Get organization user.
     * @returns any OK
     * @throws ApiError
     */
    public getOrganizationRole({
        organizationId,
        id,
        format
    }: {
        /**
         * Organization ID
         */
        organizationId: number
        /**
         * ID of the retrieved resource.
         */
        id: number
        /**
         * Permission Format
         */
        format?: PermissionFormatQuery
    }): CancelablePromise<{
        data: OrganizationRoleResource
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/organizations/{organizationId}/roles/{id}',
            path: {
                organizationId: organizationId,
                id: id
            },
            query: {
                format: format
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`
            }
        })
    }
}
